import React from 'react'
import IconUser from './icon/IconUser'
import IconOffice from './icon/IconOffice'
import IconTelephone from './icon/IconTelephone'
import IconPhone from './icon/IconPhone'
import IconVehicle from './icon/IconVehicle'

interface props {
  isPrice?: boolean
}

const SearchDropDown = ({isPrice = false}: props) => {
  return (
    <div
      className='position-absolute mt-1 z-3 text-secondary'
      style={{
        minWidth: '195px',
        fontSize: '0.875rem',
        top: '100%',
        left: 0,
        zIndex: 999,
      }}
    >
      <div
        className='position-absolute bg-white'
        style={{
          width: '8px',
          height: '8px',
          transform: 'rotate(45deg)',
          top: '-4px',
          left: '16px',
          borderTop: '1px solid rgba(255,255,255,0.1)',
          borderLeft: '1px solid rgba(255,255,255,0.1)',
        }}
      />
      <div className='card shadow p-3'>
        {!isPrice ? (
          <>
            <div className='d-flex align-items-center gap-2 pb-2 border-bottom'>
              <div style={{width: '20px'}}>
                <IconUser />
              </div>
              <span>Nom</span>
            </div>

            <div className='d-flex align-items-center gap-2 pb-2 border-bottom mt-2'>
              <div style={{width: '20px'}}>
                <IconUser />
              </div>
              <span>Prénom</span>
            </div>

            <div className='d-flex align-items-center gap-2 pb-2 border-bottom mt-2'>
              <div style={{width: '20px'}}>
                <IconOffice />
              </div>
              <span>Nom société</span>
            </div>

            <div className='d-flex align-items-center gap-2 pb-2 border-bottom mt-2'>
              <div style={{width: '20px'}}>
                <IconTelephone />
              </div>
              <span>Téléphone</span>
            </div>

            <div className='d-flex align-items-center gap-2 pb-2 border-bottom mt-2'>
              <div style={{width: '20px'}}>
                <IconPhone />
              </div>
              <span>Mobile</span>
            </div>

            <div className='d-flex align-items-center gap-2 pb-2 mt-2'>
              <div style={{width: '20px'}}>
                <IconVehicle />
              </div>
              <span>Immatriculation</span>
            </div>
          </>
        ) : (
          <>
            <div className='d-flex align-items-center gap-2 pb-2 mt-2'>
              <div style={{width: '20px'}}>
                <i className='ki-duotone ki-book'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                  <span className='path3'></span>
                  <span className='path4'></span>
                </i>
              </div>
              <span>Référence pièce</span>
            </div>

            <div className='d-flex align-items-center gap-2 pb-2 mt-2'>
              <div style={{width: '20px'}}>
                <i className='ki-duotone ki-book'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                  <span className='path3'></span>
                  <span className='path4'></span>
                </i>
              </div>
              <span>Référence OE</span>
            </div>

            <div className='d-flex align-items-center gap-2 pb-2 mt-2'>
              <div style={{width: '20px'}}>
                <i className='ki-duotone ki-price-tag'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                  <span className='path3'></span>
                </i>
              </div>
              <span>Prix</span>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export {SearchDropDown}
